<ul class='container' [dragula]='"gallery-bag"' [dragulaModel]='viewPortItems'>
  <li *ngFor="let elementId of viewPortItems;let i = index">
    <div *ngIf="this.tempElements.get(elementId)" class="top" #extra>
      <div id=imageEl{{elementId}} tabindex="0" (focus)="outerDivFocus = true" (blur)="outerDivFocus = false"
        [class]="outerDivFocus ? 'enableFocus': ''">
        <ng-container *ngIf="!EditMode">
          <div class="leadMedia">
            <label style=" visibility:hidden"></label>
            <div class="dataField">
              <div class="leadimage fl wid100">
                <div class="imageblock">
                  <div class="imagepreloader" *ngIf="!serveLoaded(elementId)">
                    <div class="a" style="--n: 5;">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                  <img [style.visibility]="serveLoaded(elementId) ? 'visible' : 'hidden'"
                    [src]="(serveElement(elementId) && serveElement(elementId).image && serveElement(elementId).image.images) ? sharedService.getImageOnPriority(serveElement(elementId).image.images, '960x540'): null"
                    (load)="imgLoaded($event,elementId)" alt="">
                </div>
                <div class="editimage fl100 spImg_story">
                  <span class="fieldValidation"
                    *ngIf="captionRestrictionEnabled && serveElement(elementId)?.image?.caption
                && sharedService.checkIfRestrictedCharactersArePresent(serveElement(elementId)?.image?.caption, 'caption')">
                    Please remove ((") ! ^ * [] {{'{}'}})</span>
                  <label [innerHTML]="serveElement(elementId)?.image?.caption"></label>

                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="EditMode">

          <ng-container tabindex="0" *ngIf="!serveEdit(elementId)">
            <div [class]="ifCroppedDomain(elementId)?'leadMedia':'leadMedia mandatoryImage'">
              <label style="visibility:hidden">Lead Media</label>
              <div class="dataField bdrfill">
                <div class="leadimage fl wid100 photoGallery_new">
                  <div class="imageblock">
                    <div class="imagepreloader" *ngIf="!serveLoaded(elementId)">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                    <img [style.visibility]="serveLoaded(elementId) ? 'visible' : 'hidden'"
                      [src]="(serveElement(elementId) && serveElement(elementId).image && serveElement(elementId).image.images) ? sharedService.getImageOnPriority(serveElement(elementId).image.images, '960x540') : null"
                      (load)="imgLoaded($event,elementId)" alt="">
                  </div>
                  <div class="editimage fl100">
                    <span class="fieldValidation"
                      *ngIf="captionRestrictionEnabled && serveElement(elementId)?.image?.caption
                  && sharedService.checkIfRestrictedCharactersArePresent(serveElement(elementId)?.image?.caption, 'caption')">
                      Please remove ((") ! ^ * [] {{'{}'}})</span>
                    <div class="dataField">
                      <label class="leftlabel">Caption<i class="mandate" *ngIf="storytype !== 'infographic'">*</i></label>
                      <button class="copyIcon" (click)="copyCaption(elementId)" title="Copy Caption"> </button>
                      <input type="text" class="textBox textShiftleft" [ngModel]="serveElement(elementId).image.caption"
                        placeholder="Add caption here" readonly title="{{serveElement(elementId).image.caption}}">
                        
                    </div>
                   
                    <div class="dataField">
                      <label>Source</label>
                      <input type="text" class="textBox" [ngModel]="serveElement(elementId).image.imageCredit"
                        placeholder="Add source here" readonly>
                    </div>
                  </div>
                </div>
              </div>
              <div class="storyaction">
                <ng-container>
                  <span id="icon-move" class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                  <span id="buttonEditForImage" class="editBtn" (click)="onelementFocus(elementId)"><i
                      class="icon-pickup"></i></span>
                  <span *ngIf="storyData.type!=='infographic'" id="" class="cropimage" (click)="startCropping(elementId)"><i class="icon-crop"></i></span>
                  <span class="deleteHeadline" (click)="deleteElement(elementId)"><i class="icon-delete"></i></span>
                  <span *ngIf="leadMediaId && (elementId === leadMediaId)" class="deleteHeadline  leadMediaNew">L</span>

                </ng-container>
              </div>

            </div>
          </ng-container>
          <ng-container *ngIf="serveEdit(elementId)">
            <div class="leadMedia">
              <label></label>
              <div class="dataField bdrfill">
                <div class="leadimage fl wid100">
                  <div class="imageblock">
                    <div class="imagepreloader" *ngIf="!serveLoaded(elementId)">
                      <div class="a" style="--n: 5;">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                    <img [style.visibility]="serveLoaded(elementId) ? 'visible' : 'hidden'"
                      [src]="(serveElement(elementId) && serveElement(elementId).image && serveElement(elementId).image.images) ? sharedService.getImageOnPriority(serveElement(elementId).image.images, '960x540') : null"
                      (load)="imgLoaded($event)" alt="">
                  </div>
                  <div class="editimage">
                    <ul class="wid100 fl leadimageform">
                      <li id="captionEl{{elementId}}">
                        <label>Caption <i class="mandate" *ngIf="storytype !== 'infographic'">*</i></label>
                        <div id="addCaptionForImage" class="dataField">
                          <span class="fieldValidation"
                            *ngIf="captionRestrictionEnabled && serveElement(elementId)?.image?.caption
                        && sharedService.checkIfRestrictedCharactersArePresent(serveElement(elementId)?.image?.caption, 'caption')">
                            Please remove ((") ! ^ * [] {{'{}'}})</span>
                          <ng-container *ngIf="isCKEditorEnabled">
                            <div (keydown)="captionKeyDownEventCk($event,elementId)">
                              <ckeditor [editor]="ckEditor" id="{{elementId}}"
                                [data]="tempElements.get(elementId).image.caption" [config]="ckconfig"
                                [tabindex]="0" (ready)="ckchanges($event, 'ready', 'caption')"
                                (change)="onChange($event,'caption',elementId)"
                                (blur)="ckchanges($event, 'blur', 'caption')"
                                (focus)="ckchanges($event, 'focus', 'caption')"
                                (error)="ckchanges($event, 'error', 'caption')"></ckeditor>
                            </div>
                          </ng-container>

                        </div>
                      </li>
                      <li>
                        <label>Title</label>
                        <div class="dataField">
                          <input type="text" class="textBox" [(ngModel)]="tempElements.get(elementId).title"
                            placeholder="Add Title here">
                        </div>
                      </li>
                      <li>
                        <div class="wid50 fl padr20">
                          <label>Name</label>
                          <div class="dataField">
                            <input type="text" class="textBox" [(ngModel)]="tempElements.get(elementId).image.name"
                            placeholder="Add Name here">
                          </div>
                        </div>
                        <div class="wid50 fr">
                          <label>Source</label>
                          <div class="dataField">
                            <input type="text" class="textBox"
                              [(ngModel)]="tempElements.get(elementId).image.imageCredit" placeholder="Add Source here">
                          </div>
                        </div>
                      </li>
                      <li>
                        <label>Tags</label>
                        <div class="dataField">
                          <tags-creator [broadInput]="true" [data]="tempElements.get(elementId).metadata.tags"
                            [displayText]="'enter tags'" (changefn)="setTags(elementId,$event)"></tags-creator>
                        </div>
                      </li>
                      <li>
                        <label>URL</label>
                        <div class="dataField">
                          <input type="text" class="textBox" [(ngModel)]="tempElements.get(elementId).image.imageUrl"
                          #url="ngModel"
                          pattern="[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?"
                          placeholder="Add URL here">
                        </div>
                          <div *ngIf="url.touched">
                          <p *ngIf="url.errors?.pattern" style="color:red">Please enter a valid url.</p>
                        </div>
                      </li>
                      <li class="summary relatedstories imageRelatedStories body"
                        *ngIf="enableRelatedStoryInlineImage.indexOf(storytype)>-1">
                        <label>Related Stories
                          <div class="related_icon spImg_story"
                            (click)="openRelatedStoryForImageTypeModal('single',elementId)" id="buttonRelatedStory">
                            <span class="tooltip">Add/Replace Related Story</span>
                          </div>
                        </label>
                        <div class="dataField">
                          <ng-container *ngFor="let story of tempElements.get(elementId).relatedStories;let i = index">
                            <div #relatedStoryRef class="related-story-view" [arrayIndex]="i" [storyId]="story"
                              [relatedStoryType]="relatedStoryType"
                              (receivedRelatedStoryHeadline)="receivedRelatedStoryHeadline($event,elementId,story)">
                              <!--input id="{{elementId}}-{{story}}" type="text" class="textBox" readonly placeholder="add related story"-->
                            </div>
                          </ng-container>
                        </div>
                      </li>
                      <li class="selectlead" *ngIf="showToggle">
                        <label>Set as Lead Media</label>
                        <div class="dataField">
                          <label class="switch">
                            <input type="checkbox" (click)="setThisAsLeadMedia(elementId)"
                              [checked]="leadMediaId && (elementId === leadMediaId)">
                            <span class="slider round"></span> </label>
                        </div>
                      </li>
                      <div *ngIf="enableAmazonMeta">
                        <li *ngIf="tempElements.get(elementId).hasOwnProperty('amazonMeta') 
                        && tempElements.get(elementId).hasOwnProperty('amazonTitle') 
                        && tempElements.get(elementId).hasOwnProperty('amazonAds') 
                        && tempElements.get(elementId).amazonAds.length>0" class="selectlead">
                          <label>Amazon Meta</label>
                          <div class="dataField">
                            <label class="switch">
                              <input type="checkbox" (click)="setThisAmazonMeta(elementId,$event)" 
                                [checked]="tempElements.get(elementId).amazonMeta">
                              <span class="slider round"></span> </label>
                          </div>
                        </li>
                        <div class="dataField amazon-detail-box" *ngIf="tempElements.get(elementId).hasOwnProperty('amazonMeta') 
                        && tempElements.get(elementId).hasOwnProperty('amazonTitle') 
                        && tempElements.get(elementId).hasOwnProperty('amazonAds') 
                        && tempElements.get(elementId).amazonAds.length>0 
                        && tempElements.get(elementId).amazonMeta">
                          <div *ngIf=" 
                          tempElements.get(elementId).hasOwnProperty('amazonCheckedItem') 
                          && !tempElements.get(elementId).amazonCheckedItem">
                            <li>
                              <label>Add Amazon Custom Ads</label>
                              <div class="dataField">
                                <input type="text" class="textBox" [(ngModel)]="tempElements.get(elementId).amazonTitle"
                                placeholder="Enter Ad title here">
                              </div>
                            </li>
                            <li>
                              <div class="dataField">
                                <input type="text" class="textBox" [(ngModel)]="tempElements.get(elementId).amazonAds[0].key"
                                placeholder="Enter Ad Name here">
                              </div>
                            </li>
                            <li>
                              <div class="dataField">
                                <input type="text" class="textBox" [(ngModel)]="tempElements.get(elementId).amazonAds[0].value"
                                placeholder="Enter Ad Embed here">
                              </div>
                            </li>
                          </div>
                          <div *ngIf="tempElements.get(elementId).hasOwnProperty('amazonCheckedItem') 
                           &&tempElements.get(elementId).amazonCheckedItem">
                            <h6>{{tempElements.get(elementId).amazonTitle}}</h6>
                            <span>{{tempElements.get(elementId).amazonAds[0].key}}:</span>
                            <span>{{tempElements.get(elementId).amazonAds[0].value}}</span>
                            <span *ngIf="!tempElements.get(elementId).amazonAds[0].isPresent">❌</span>
                            <span *ngIf="tempElements.get(elementId).amazonAds[0].isPresent">✅</span>
                          </div>
                                <li>
                              <button *ngIf="tempElements.get(elementId).hasOwnProperty('amazonCheckedItem') 
                                  &&!tempElements.get(elementId).amazonCheckedItem"  tabindex="0" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                              (click)="checkItemsAmazonMeta(elementId)" [class]="'save blue'" style="margin-left: 0;margin-top: 1rem;">Add</button>
                              <button *ngIf="tempElements.get(elementId).hasOwnProperty('amazonCheckedItem') 
                              &&tempElements.get(elementId).amazonCheckedItem" tabindex="0" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                              (click)="editAmazonData(elementId)" [class]="'save blue'"  style="margin-left: 0;margin-top: 1rem;">Edit</button>
                                </li>
                        </div>
                      </div>
                    </ul>
                    <div class="fr wid100 right">
                      <button tabindex="0" type="button" name="revertCard" class="createCard gray mtb15 ml10"
                        (click)="discardMetaChanges(elementId)">Revert</button>
                      <button tabindex="0" type="button" name="saveStory" class="createStory blue mtb15 ml10 mr30"
                        (click)="setChangesMeta(elementId)" [class]="'save blue'">Done</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="storyaction">
                <ng-container>
                  <span class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
                  <span class="deleteHeadline" (click)="deleteElement(elementId)"><i class="icon-delete"></i></span>
                </ng-container>
              </div>

            </div>
          </ng-container>

        </ng-container>
      </div>
    </div>
  </li>
</ul>

<div [class]="showRelatedStoryPopup ? 'lightBox listrelatedstories block' : 'lightBox'">
  <div class="headerLight">
    <div class="close fl spImg" (click)="closeRelatedStoryModal()"></div>
  </div>
  <div class="related-story-listing" [chooseMultiple]="relatedStoryMultipleSelectFlag"
    (sendIdListToParentfn)="getRelatedStoryIds($event)" (closePopupEmit)="closeRelatedStoryModal()"
    (sendRelatedStoryData)="getRelatedStoryData($event)" [exclusionList]="relatedStoryTempList"
    *ngIf="showRelatedStoryPopup" [storyId]="storyId" [relatedStoryType]="relatedStoryType"></div>
</div>

<div class="image-cropper" *ngIf="showCropper" [cropperImageUrl]="cropperImageUrl" (finish)="finishCropping($event)"
  (cancel)="cancelCropping($event)"
  [verticalImageFlag]="(tempElements.get(id[0]).image && tempElements.get(id[0]).image.verticalImage)"></div>